module.exports = __webpack_public_path__ + "4466317341560ee2759326c4723cae25.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-BoldItalic.svg
// module id = 339
// module chunks = 0